import { render, staticRenderFns } from "./Prodetail.vue?vue&type=template&id=5a471ed4&"
import script from "./Prodetail.vue?vue&type=script&lang=js&"
export * from "./Prodetail.vue?vue&type=script&lang=js&"
import style0 from "./Prodetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports